module.exports = __webpack_public_path__ + "img/active-list2.572e237f.png";